import React, { useContext } from 'react'

import useDataLayer from 'src/hooks/useDataLayer/dataLayerBody'
import { ThemeContext } from 'styled-components'

import IcInter from '@interco/icons/core/brands/ic_inter'

import { UL } from './style'

const FollowTheInset = () => {
  const { colors } = useContext(ThemeContext)

  const [sendDatalayerEvent] = useDataLayer()
  const urlForum = 'https://blog.inter.co/forum-o-que-e-e-como-funciona-a-rede-social-do-inter/'

  return (
    <>
      <p className="fs-14 lh-17 fw-600 text-grayscale--500">Siga o Inter</p>
      <UL>
        <a
          href={urlForum}
          target="_blank"
          title="Forum Inter"
          rel="noopener noreferrer"
          onClick={() => {
            sendDatalayerEvent({
              section: '',
              element_action: 'click button',
              element_name: 'Forum Inter',
              redirect_url: urlForum,
            })
          }}
        >
          <IcInter height={25} width={25} color={colors.primary} />
        </a>
      </UL>
    </>
  )
}

export default FollowTheInset
